module.exports = __webpack_public_path__ + "static/media/logo.c826a92d.svg";